import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminEntrancesIndex } from '@/types';
import { EntranceSearch } from './components/EntranceSearch';
import { EntranceTable } from './components/EntranceTable';

export default function Index({
  title,
  eventSlug,
  search,
  people,
  stats,
}: AdminEntrancesIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Entrance</h1>
          <p className="text-muted-foreground">
            Register entrances to the event
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Search</CardTitle>
          </CardHeader>
          <CardContent>
            <EntranceSearch
              eventSlug={eventSlug}
              currentSearch={search}
              stats={stats}
            />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <EntranceTable people={people} eventSlug={eventSlug} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
